// extracted by mini-css-extract-plugin
export default {"innerContainer":"CreateVariant_innerContainer__HcIrm","submitContainer":"CreateVariant_submitContainer__VQI2d","submitMessage":"CreateVariant_submitMessage__EitKB"};